import { render, staticRenderFns } from "./EDCSystem.vue?vue&type=template&id=be77cc1c"
import script from "./EDCSystem.vue?vue&type=script&lang=js"
export * from "./EDCSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports